export default __webpack_public_path__ + "static/media/9141 - NGBxBen.0ce0ee99.jpeg";